<div class="branch-zip-lookup">
	<label class="branch-zip-lookup__label" for="branchZipLookup">
		Branch ZIP Lookup <span class="branch-zip-lookup__optional">(optional)</span>
	</label>

	<input
		pInputText
		id="branchZipLookup"
		class="branch-zip-lookup__input"
		type="text"
		name="branchZipLookup"
		inputmode="numeric"
		autocomplete="off"
		maxlength="5"
		placeholder="e.g. 78701"
		aria-describedby="branchZipLookupHint branchZipLookupResult"
		[disabled]="disabled"
		[value]="zipcode"
		(input)="onZipInput($event)"
		(keydown.enter)="$event.preventDefault()"
	/>

	<small id="branchZipLookupHint" class="branch-zip-lookup__hint">
		Finds the branch that services this ZIP and selects it below. Not saved to the patient.
	</small>

	<div
		id="branchZipLookupResult"
		class="branch-zip-lookup__result"
		[ngClass]="'branch-zip-lookup__result--' + state"
		aria-live="polite"
	>
		<i class="branch-zip-lookup__icon" [ngClass]="resultIcon" aria-hidden="true"></i>
		<span>{{ resultMessage }}</span>
	</div>
</div>
